import {
    PAYLOAD_TYPE_JSON,
    PAYLOAD_TYPE_FORMDATA
} from "@main/helpers/const";

export function batchReplace(string, map = {}) {
    return Object.keys(map).reduce((acc, key) => {
        return acc.replace(key, map[key]);
    }, string || "");
}

export function buildQuery(data) {
    return Object.keys(data)
        .reduce((acc, key) => {
            if (!data[key] || (Array.isArray(data[key]) && !data[key].length)) {
                return acc;
            }

            const expression = Array.isArray(data[key])
                ? data[key].map(value => `${encodeURIComponent(key)}[]=${encodeURIComponent(value)}`).join("&")
                : `${key}=${encodeURIComponent(data[key])}`;

            return !acc ? expression : `${acc}&${expression}`;
        }, "");
}

/**
 * @param {string} url
 * @param {*} data
 * @param {string} method
 * @param {string} payloadType
 * @returns {Promise<Response>}
 */
export async function performFetch(
    url,
    data = null,
    method = "GET",
    payloadType = PAYLOAD_TYPE_FORMDATA
) {
    const params = {
        credentials: "include",
        method: method,
        headers: new Headers({
            "X-Requested-With": "XMLHttpRequest",
        })
    };

    if ((String(params.method).toUpperCase() === "POST") && data) {
        Object.assign(params, {
            body: data,
        })
    }

    if ((payloadType === PAYLOAD_TYPE_JSON) && data) {
        Object.assign(params, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
        })
    }

    return fetch(url, params);
}
